import { Command } from '@/app/common/base/command'

export class CreateDossierCommand extends Command {
    public async run(data: object) {
        await this.client.post(`/api/create-dossier`, data)
    }
}
